import { Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const MemberListSkeleton = () => {
  const rows = 5; 
  
  return (
    <TableContainer component={Paper} elevation={0} >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><Skeleton variant="text" width={100} /></TableCell>
            <TableCell><Skeleton variant="text" width={100} /></TableCell>
            <TableCell><Skeleton variant="text" width={100} /></TableCell>
            <TableCell><Skeleton variant="text" width={100} /></TableCell>
            <TableCell><Skeleton variant="text" width={100} /></TableCell>
            <TableCell><Skeleton variant="text" width={100} /></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          
          {Array.from(new Array(rows)).map((_, index) => (
            <TableRow key={index}>
              <TableCell><Skeleton variant="rectangular" width="100%" height={40} /></TableCell>
              <TableCell><Skeleton variant="rectangular" width="100%" height={40} /></TableCell>
              <TableCell><Skeleton variant="rectangular" width="100%" height={40} /></TableCell>
              <TableCell><Skeleton variant="rectangular" width="100%" height={40} /></TableCell>
              <TableCell><Skeleton variant="rectangular" width="100%" height={40} /></TableCell>
              <TableCell><Skeleton variant="rectangular" width="100%" height={40} /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MemberListSkeleton;
